import { Col, Row } from 'antd';
import React from 'react';
import { IOrderHeaderCardsProps } from './OrderHeaderCards.props';

// No caption row and no caption over each card: the show/hide toggle lives in the drawer or page
// header, and what the cards hold is obvious from their content.
export const OrderHeaderCardsPresentation: React.FC<IOrderHeaderCardsProps> = ({
  jobCard,
  customerCard,
  invoiceCard,
  expanded = true,
}) =>
  expanded ? (
    <Row gutter={[8, 16]} style={{ margin: '0 8px', background: '#fafcff' }}>
      <Col span={8}>{jobCard}</Col>
      <Col span={8}>{customerCard}</Col>
      <Col span={8}>{invoiceCard}</Col>
    </Row>
  ) : null;
